import React, { useState } from 'react';
import { _dataProvider } from '../dataProvider/DataProvider';
import { useTranslation } from 'react-i18next';
import './Dialog.css';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { Dialog } from '@fluentui/react/lib/Dialog';
import { ResponsiveMode } from '@fluentui/react';
import closeIcon from '../img/close.png';
import { getDialogThemeClassName, getThemedModalMainStyles } from './dialogStyles';
import { COMMON_DIALOG_CONTENT_STYLES, COMMON_HEADER_BUTTON_STYLES } from './shellStyles';
import { useIdigestChatTheme } from '../ThemeContext';

interface IAddContactProps {
  onClose: () => void;
  launchOneOnOneWithFriend: any;
}

const AddNewContactWindow: React.FC<IAddContactProps> = ({ onClose, launchOneOnOneWithFriend }) => {
  const { t } = useTranslation();
  const { theme, tokens } = useIdigestChatTheme();
  const [email, setEmail] = useState('');
  const [introduction, setIntroduction] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleIntroductionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setIntroduction(event.target.value);
  };

  const handleSubmit = async () => {
    if (submitting || !email.trim()) {
      return;
    }
    setSubmitting(true);
    try {
      const result = await _dataProvider.inviteUser(email, introduction);
      if (result) {
        if (result.emailSent) {
          alert(t('AddFriendScreen.EmailNotUser').replace('{email}', email));
        } else {
          launchOneOnOneWithFriend(result.userId, introduction, email.trim());
        }
        onClose();
      } else {
        alert(t('FailedToAddContact'));
      }
    } catch (error) {
      console.error('Failed to add contact:', error);
      alert(t('FailedToAddContact'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      hidden={false}
      responsiveMode={ResponsiveMode.small}
      onDismiss={onClose}
      dialogContentProps={{
        showCloseButton: false,
        styles: {
          inner: { padding: '0px' },
          header: { height: '0px' },
          content: COMMON_DIALOG_CONTENT_STYLES
        }
      }}
      modalProps={{
        isBlocking: false,
        styles: { main: getThemedModalMainStyles(theme) },
        containerClassName: getDialogThemeClassName(theme)
      }}
    >
      <div className='header-section'>
        <div className='button-wrapper left-btn' />
        <h3 className='header-title' style={{ fontWeight: 600, fontSize: '18px' }}>
          {t('AddFriendScreen.AddFriend')}
        </h3>
        <div className='button-wrapper right-btn'>
          <DefaultButton className='header-button' styles={COMMON_HEADER_BUTTON_STYLES} onClick={onClose}>
            <img src={closeIcon} alt={t('Close')} className='button-icon' />
          </DefaultButton>
          <span className='button-label'>{t('Close')}</span>
        </div>
      </div>
      <div className='add-friend-body'>
        <div className='add-friend-field'>
          <p className='add-friend-label'>{t('AddFriendScreen.EnterFriendEmail')}</p>
          <input
            id='contactEmail'
            className='dialog-box'
            type='email'
            value={email}
            onChange={handleEmailChange}
            autoComplete='email'
          />
        </div>
        <div className='add-friend-field'>
          <p className='add-friend-label'>{t('AddFriendScreen.SelfIntro')}</p>
          <textarea
            id='contactIntroduction'
            className='dialog-box'
            value={introduction}
            onChange={handleIntroductionChange}
            rows={4}
          />
        </div>
        <DefaultButton
          onClick={handleSubmit}
          disabled={submitting || !email.trim()}
          styles={{
            root: {
              margin: '12px auto 0',
              minWidth: 120,
              backgroundColor: tokens.fg,
              color: tokens.bg,
              borderRadius: '25px',
              border: 'none'
            },
            rootHovered: {
              backgroundColor: tokens.surfaceHover,
              color: tokens.fg
            },
            rootDisabled: {
              backgroundColor: tokens.muted,
              color: tokens.bg,
              cursor: 'not-allowed'
            }
          }}
        >
          {submitting ? t('Loading') : t('OK')}
        </DefaultButton>
      </div>
    </Dialog>
  );
};

export default AddNewContactWindow;
